<template>
    <div class="popup">
        <h2 class="popup__title">
            {{$t("popupTitle")}}
        </h2>
        <div class="popup__row">
            <div class="popup__col">
                {{$t("popupRadiusControl")}}
            </div>
            <div class="popup__action">
                <radiusControls @saveCircleData="saveCircleData" :min="1" :max="10000" :circle="circleData" :value="circleData.radius"></radiusControls>
            </div>
        </div>
        <div class="popup__row">
            <div class="popup__col">
                {{$t("popupReport")}}
            </div>
            <div class="popup__action">
                <pdfReport :circle="circleData" :isCircleMode="true"/>
            </div>
        </div>
        <div class="popup__row">
            <Button type="button" class="btn btn-delete" @click="circleRemoveHandler">{{$t("popupCircleRemove")}}</Button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import radiusControls from './circleRadiusControls.vue'
    import pdfReport from '../popup/popupPdfReport.vue'

    export default Vue.extend({
        data() {
            return {
              circleData: {}
            }
        },
        props: {
            circle: {
                type: Object,
                required: true
            },
            popup: {
                type: Object
            }
        },
        components: {
            radiusControls,
            pdfReport
        },
        methods: {
            saveCircleData(data) {
                this.circleData = data
            },
            circleRemoveHandler() {
                this.popup.remove();
                this.$store.dispatch('REMOVE_DRAWING_CIRCLE');
                this.$store.dispatch('FETCH_DRAWING_CIRCLE_DATA');
            }
        },
        created() {
            this.circleData = Object.assign(this.circleData, this.circle)
        },

    })
</script>
<style lang="sass" scoped>
    .popup
        &__title
            font-size: 14px
            color: #01254E
            margin-bottom: 11px
</style>